// extracted by mini-css-extract-plugin
export default {"r_l":"_6bb1c38c7c _10587e1d2b","t":"f125c5ebe6"};